import Carousel from './carousel';

class BlogEntrySliderCarousel extends Carousel {
  constructor(selector: any = '.js-o-blog-entry-slider-carousel', settings: object = {}) {
    const TIME = 5000;
    const SPEED = 800;

    const carousel: HTMLElement | null | undefined = document.querySelector(selector)?.closest('.o-blog-entry-slider');
    const el: HTMLElement | null = document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-blog-entry-slider__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      speed: SPEED,
      slidesPerView: (window.innerWidth >= 768 ? 2.1 : 1.3),
      spaceBetween: (window.innerWidth >= 768 ? (window.innerWidth > 1024 ? 60 : 30) : -17),
      loop: true,
      autoplay: {
        delay: TIME,
      },
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: function(swiper: any) {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
          carousel?.style.setProperty('--slide-width', `${swiper.slidesSizesGrid[0]}px`);

          setTimeout(() => {
            if ((window.innerWidth > 768 && swiper.slides.length - 2 <= 3) || (window.innerWidth <= 768 && swiper.slides.length - 2 <= 1)) {
              swiper.autoplay.stop();
              swiper.unsetGrabCursor();
              swiper.params.grabCursor = false;
              swiper.params.loop = false;
            }
          }, 2100);
        },
        resize: function(swiper: any) {
          carousel?.style.setProperty('--slide-width', `${swiper.slidesSizesGrid[0]}px`);
        },
      },
    });
  }
}

export default BlogEntrySliderCarousel;
